import { render, staticRenderFns } from "./SimpleLanguages.vue?vue&type=template&id=3f92fb12&scoped=true"
import script from "./SimpleLanguages.vue?vue&type=script&lang=js"
export * from "./SimpleLanguages.vue?vue&type=script&lang=js"
import style0 from "./SimpleLanguages.vue?vue&type=style&index=0&id=3f92fb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92fb12",
  null
  
)

export default component.exports